import gql from "graphql-tag";

export const addRoomM = gql`
    mutation AddRoom(
        $name: String!,
        $link: String!,
        $branch: ID!
    ){
        addRoom(
            name: $name,
            link: $link,
            branch: $branch
        ) {
            _id,
            name
        }
    }
`;

export const updateRoomM = gql`
    mutation UpdateRoom(
        $_id: ID!,
        $name: String!,
        $link: String!,
        $branch: ID!
    ){
        updateRoom(
            _id: $_id,
            name: $name,
            link: $link,
            branch: $branch
        ) {
            _id,
            name
        }
    }
`;

export const removeRoomM = gql`
    mutation RemoveRoom(
        $_id: ID!
    ){
        removeRoom(
            _id: $_id
        ) {
            _id,
            name,
        }
    }
`;


// WEBPACK FOOTER //
// ./src/graphql/mutation/room.js